import { FC, useRef } from 'react';
import './style.scss';
import { Row, Col } from 'antd';
import moment from 'moment';
import { NET, OTHER } from '../enum';

const List: FC<{
    data: Record<string, any>;
    imgData?: any[];
    options: Record<string, any>[];
}> = ({ data = {}, imgData = [], options = [] }) => {
    const toPdfRef = useRef<HTMLDivElement>(null);

    function findName(val: string): string {
        const [item] = options?.filter(({ dictBn }) => dictBn === val);
        return item?.name || '';
    }

    function getMediaOptions() {
        const data = options.filter(({ type }) => type === 'media');
        return data.map(({ name, dictBn }) => ({
            label: name,
            value: dictBn
        }));
    }

    const media = data?.media || [];

    return (
        <div className='pdf-box' ref={toPdfRef}>
            <div style={{ textAlign: 'right', paddingRight: 15 }}>申请受理号 _______________</div>
            <h1>四川省医疗广告成品样件表</h1>
            <div style={{ textAlign: 'right', paddingRight: 15 }}>
                提交日期：{moment(new Date()).format('YYYY年MM月DD日')}
            </div>
            <div className='pdf-body'>
                <Row className='ant-row-c'>
                    <Col span={2} className='ant-col-c'>
                        医<br />
                        疗<br />
                        机<br />
                        构<br />
                        情<br />况
                    </Col>
                    <Col span={22}>
                        <Row className='ant-row-c'>
                            <Col span={4} className='ant-col-c pdf-item-lable'>
                                第一名称
                            </Col>
                            <Col span={20} className='ant-col-c'>
                                {data.orgName || ''}
                            </Col>
                        </Row>
                        <Row className='ant-row-c'>
                            <Col span={4} className='ant-col-c pdf-item-lable'>
                                地址
                            </Col>
                            <Col span={20} className='ant-col-c'>
                                {data.address || ''}
                            </Col>
                        </Row>
                        <Row className='ant-row-c'>
                            <Col span={4} className='pdf-item-lable ant-col-c'>
                                机构类别
                            </Col>
                            <Col span={8} className='ant-col-c'>
                                {findName(data.category_wj) || ''}
                            </Col>
                            <Col span={4} className='ant-col-c'>
                                执业许可证
                                <br />
                                登记号
                            </Col>
                            <Col className='ant-col-c' span={8}>
                                {data.registerBn || ''}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={4} className='ant-col-c'>
                                法定代表人
                                <br />
                                （主要负责人）
                            </Col>
                            <Col span={8} className='ant-col-c'>
                                {data.legalPerson || ''}
                                <br />
                                {data.principal ? `(${data.principal})` : ''}
                            </Col>
                            <Col span={4} className='pdf-item-lable ant-col-c'>
                                联系电话
                            </Col>
                            <Col className='ant-col-c' span={8}>
                                {data.phone || ''}
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className='ant-row-c'>
                    <Col span={6} className='pdf-item-lable ant-col-c'>
                        拟发布媒体类别
                    </Col>
                    <Col
                        span={18}
                        className='ant-col-c'
                        style={{ flexWrap: 'inherit', justifyContent: 'start' }}
                    >
                        {getMediaOptions().map(({ label, value }, index) => (
                            <span
                                key={index}
                                className={[
                                    'check-box',
                                    data?.media && data?.media?.includes(value) ? 'selected' : null
                                ].join(' ')}
                                style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
                            >
                                {value === NET && media.includes(value) && !!data.publish
                                    ? `${label}`//(${data.publish})
                                    : value === OTHER && media.includes(value) && !!data.other
                                    ? `${label}(${data.other})`
                                    : label}
                            </span>
                        ))}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <div style={{ flex: 1, padding: '5px 10px' }}>广告成品样件粘贴处：</div>
                    <Col
                        span={24}
                        className='ant-col-c'
                        style={{
                            border: 'none',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            paddingBottom: 0,
                            paddingTop: 5
                        }}
                        id='yj-img-box'
                    >
                        {imgData.length ? null : (
                            <div
                                style={{
                                    width: 400,
                                    height: 300,
                                    border: '1px dashed #999'
                                }}
                            ></div>
                        )}
                        {imgData.map((item: Record<string, any>, index: number) => (
                            <div
                                key={index}
                                className='img_item'
                                style={{
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                    height: '460px',
                                    overflow: 'hidden'
                                }}
                            >
                                <img
                                    src={item.url}
                                    style={{
                                        maxWidth: 858,
                                        maxHeight: 420
                                    }}
                                    draggable='false'
                                    alt=''
                                />
                                <div style={{ textAlign: 'center', marginBottom: 5 }}>
                                    图 ({index + 1}) {item?.type ? item?.type.join('、') : ''}
                                </div>
                            </div>
                        ))}
                    </Col>
                    <div style={{ flex: 1, padding: '15px', textAlign: 'center' }}>
                        <span style={{ marginRight: '40%' }}>(医疗机构盖章)</span>
                        <span>(审查机关盖章)</span>
                    </div>
                    <div style={{ padding: 10, textIndent: '28px' }}>
                    医疗广告发布法律责任：
                     按照《中华人民共和国广告法》第五十五条　违反本法规定，发布虚假广告的，由市场监督管理部门责令停止发布广告，责令广告主在相应范围内消除影响，处广告费用三倍以上五倍以下的罚款，广告费用无法计算或者明显偏低的，处二十万元以上一百万元以下的罚款；两年内有三次以上违法行为或者有其他严重情节的，处广告费用五倍以上十倍以下的罚款，广告费用无法计算或者明显偏低的，处一百万元以上二百万元以下的罚款，可以吊销营业执照，并由广告审查机关撤销广告审查批准文件、一年内不受理其广告审查申请。<br/>
医疗机构有前款规定违法行为，情节严重的，除由市场监督管理部门依照本法处罚外，卫生行政部门可以吊销诊疗科目或者吊销医疗机构执业许可证。<br/>
 按照《中华人民共和国广告法》第五十八条　有下列行为之一的，由市场监督管理部门责令停止发布广告，责令广告主在相应范围内消除影响，处广告费用一倍以上三倍以下的罚款，广告费用无法计算或者明显偏低的，处十万元以上二十万元以下的罚款；情节严重的，处广告费用三倍以上五倍以下的罚款，广告费用无法计算或者明显偏低的，处二十万元以上一百万元以下的罚款，可以吊销营业执照，并由广告审查机关撤销广告审查批准文件、一年内不受理其广告审查申请：<br/>
（一）违反本法第十六条规定发布医疗、药品、医疗器械广告的；<br/>
（二）违反本法第十七条规定，在广告中涉及疾病治疗功能，以及使用医疗用语或者易使推销的商品与药品、医疗器械相混淆的用语的。

                    </div>
                </Row>
            </div>
            <div className='page-box' id='footer'></div>
        </div>
    );
};

export default List;
